import type { DocumentRedactResult } from "@/lib/queries/pii-file-scan";

let documentRedactFile: File | null = null;
let documentRedactResult: DocumentRedactResult | null = null;

export const documentRedactorState = {
  setFile(file: File | null) {
    documentRedactFile = file;
    documentRedactResult = null;
  },
  getFile() {
    return documentRedactFile;
  },
  setResult(result: DocumentRedactResult | null) {
    documentRedactResult = result;
  },
  getResult() {
    return documentRedactResult;
  },
  clear() {
    documentRedactFile = null;
    documentRedactResult = null;
  },
};
